import { BaseMethodReturnType } from 'src/types/commonTypes';
import { IConnectionInfoSubsystemStrategy } from '../types';

export default class BrowserConnectionInfoStrategy
  implements IConnectionInfoSubsystemStrategy
{
  async hasInternetAccess(): Promise<BaseMethodReturnType<boolean>> {
    return {
      result: navigator.onLine
    };
  }

  async listenHasInternetAccess(
    callback: (hasInternetAccess: boolean) => void
  ): Promise<BaseMethodReturnType<{ remove: () => void }>> {
    const listener = () => callback(navigator.onLine);
    window.addEventListener('online', listener);
    window.addEventListener('offline', listener);

    const remove = () => {
      window.removeEventListener('online', listener);
      window.removeEventListener('offline', listener);
    };

    return {
      result: { remove }
    };
  }
}
